import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { bpcApi } from '@core/services/bpc-api.service';
import { StripeConnectStatus } from '@accounting/interfaces/stripe-connect-status';
import BPCMessageService from '@core/services/bpc-messages.service';

export default class BPCStripeConnectService {
  protected $bpcApiRouteHelper: BPCApiRouteHelper;
  protected $bpcApi: typeof bpcApi;
  protected $bpcMessage: BPCMessageService;

  constructor() {
    this.$bpcApiRouteHelper = new BPCApiRouteHelper();
    this.$bpcApi = bpcApi;
    this.$bpcMessage = new BPCMessageService();
  }

  async getStripeConnectStatus(): Promise<StripeConnectStatus> {
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('stripe-connects')}/status`;
    const res = await this.$bpcApi.get(fetchEntityPath, null).toPromise();
    return res.data;
  }

  async getStripeConnectLink(): Promise<string> {
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('stripe-connects')}/url`;
    const res = await this.$bpcApi.get(fetchEntityPath, null).toPromise();
    return res.data;
  }

  async redirectStripeConnect() {
    try {
      const urlRedirect = await this.getStripeConnectLink();
      window.open(urlRedirect, '_blank');
    } catch (error) {
      console.error('Stripe Connect configuration error:', error);

      const errorMessage = error?.response?.data?.message || 'global.generic.error_action';

      this.$bpcMessage.showErrorMessage({
        text: errorMessage,
        timeout: errorMessage !== 'global.generic.error_action' ? 10000 : 5000,
      });
    }
  }
}
